export default {
  placeholder: 'Cerca ristorante...',
};
